export default "__VITE_ASSET__DiT2tRCU__"